import {
  DOWNLOAD_BALANCE_REPORT_FAILURE,
  DOWNLOAD_BALANCE_REPORT_REQUEST,
  DOWNLOAD_BALANCE_REPORT_RESET,
  DOWNLOAD_BALANCE_REPORT_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const downloadBalanceReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_BALANCE_REPORT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
        success: false,
        message: "",
      })

    case DOWNLOAD_BALANCE_REPORT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      })

    case DOWNLOAD_BALANCE_REPORT_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      })

    case DOWNLOAD_BALANCE_REPORT_RESET:
      return Object.assign({}, initialState)

    default:
      return state
  }
}

export default downloadBalanceReportReducer
